import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { Modal } from 'semantic-ui-react';
import { Theme } from 'config';

import Button from 'components/Button';
import { ClassProp } from 'helpers/types';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
  showModal: boolean;
  seconds: number;
  handleOnClose: () => void;
};

const styles = (theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  logoutButton: {
    fontSize: '.875rem',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    backgroundColor: `${theme.violet} !important`,
    color: '#fff !important',
    fontSize: '.875rem',
  },
});

const LogoutModal: FunctionComponent<Props> = ({
  classes,
  showModal,
  handleOnClose,
  seconds,
}) => {
  return (
    <Modal open={showModal} size="tiny">
      <Modal.Header>Session Timeout</Modal.Header>
      <Modal.Content>
        <p>
          You’ll be logged out shortly for inactivity <br />
          Please choose to stay logged. Otherwise, you will be automatically
          logged out in 1 minute.
        </p>
        <div className={classes.buttons}>
          <Button
            disabled={seconds == 0}
            className={classes.button}
            onClick={handleOnClose}
          >
            Stay Logged In
          </Button>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default withStyles(styles)(LogoutModal);
